var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"obi-dashboard"},[_c('ObiHeader'),_c('ObiContent',[_c('template',{slot:"sidebar"},[_c('ObiSidebar')],1),_c('template',{slot:"content"},[_c('router-view')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }